import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { UpdatesTimeline } from "./updates/UpdatesTimeline";
import { FeaturesGrid } from "./features/FeaturesGrid";
import { FeedbackSection } from "./feedback/FeedbackSection";
import { UpdateItem } from "./updates/types";

const completedUpdates: UpdateItem[] = [
  {
    version: "v1.7",
    title: "Afbeeldingen Import",
    date: "Maart 2024",
    description: "Nieuwe functie toegevoegd: importeer je eigen afbeeldingen in de plattegrond editor. Sleep afbeeldingen naar de editor of gebruik de importeer knop om je eigen materiaal toe te voegen.",
    label: "Latest"
  },
  {
    version: "v1.6",
    title: "Community Update",
    date: "Februari 2024",
    description: "Nieuwe community functies toegevoegd: beoordeel plattegronden met sterren, plaats reacties en ontdek featured plattegronden die hoog gewaardeerd zijn door de community."
  },
  {
    version: "v1.5",
    title: "Gedeelde Database",
    date: "Februari 2025",
    description: "Nieuwe gedeelde database voor lesplannen toegevoegd: categoriseer je plattegronden, deel ze met de community en laat je inspireren door anderen.",
  },
  {
    version: "v1.4",
    title: "Organisatie Update",
    date: "Februari 2025",
    description: "Nieuwe organisatie functies toegevoegd: tags om plattegronden te categoriseren, mappen om ze te groeperen, en de mogelijkheid om favorieten op te slaan voor snelle toegang.",
  },
  {
    version: "v1.3",
    title: "Verbeterde Editor",
    date: "Februari 2025",
    description: "Nieuwe functies zoals roteren, spiegelen en dupliceren van toestellen en een preview functie om al je plattegronden te zien in één overzicht.",
  },
  {
    version: "v1.2",
    title: "Export Functies",
    date: "Februari 2025",
    description: "Export mogelijkheden naar PDF en afbeeldingen toegevoegd."
  },
  {
    version: "v1.1",
    title: "Activiteiten-editor 2.0",
    date: "Februari 2025",
    description: "De activiteiten-editor heeft nu een nieuwe design met meer functies en invulmogelijkheden."
  },
  {
    version: "v1.0",
    title: "Turnles Planner",
    date: "Februari 2025",
    description: "De eerste versie van Turnles Planner is gelanceerd! Een nieuwe manier om je turnlessen voor te bereiden."
  }
];

export function ComingSoonSection() {
  const [isTimelineExpanded, setIsTimelineExpanded] = useState(false);
  const [isFeaturesExpanded, setIsFeaturesExpanded] = useState(false);

  return (
    <div className="space-y-12">
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-semibold text-gray-900">Updates</h2>
          <button
            onClick={() => setIsTimelineExpanded(!isTimelineExpanded)}
            className="flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-gray-900"
          >
            {isTimelineExpanded ? (
              <>
                Inklappen <ChevronUp className="h-4 w-4" />
              </>
            ) : (
              <>
                Uitklappen <ChevronDown className="h-4 w-4" />
              </>
            )}
          </button>
        </div>

        {isTimelineExpanded && (
          <UpdatesTimeline updates={completedUpdates} />
        )}
      </div>

      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-semibold text-gray-900">Toekomstige Functies</h2>
          <button
            onClick={() => setIsFeaturesExpanded(!isFeaturesExpanded)}
            className="flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-gray-900"
          >
            {isFeaturesExpanded ? (
              <>
                Inklappen <ChevronUp className="h-4 w-4" />
              </>
            ) : (
              <>
                Uitklappen <ChevronDown className="h-4 w-4" />
              </>
            )}
          </button>
        </div>

        {isFeaturesExpanded && <FeaturesGrid />}
      </div>

      <FeedbackSection />
    </div>
  );
}
